import BHowInterpreting from './BHowInterpreting'

export default BHowInterpreting
